import React from "react";
import "./FilterSidebar.css";
import "../Pages/Cart.css";
import cartImg from "../assets/images/cartImg.png";
import Cart from '../Pages/Cart';
import Checkout from '../Pages/Checkout';
import { Link } from "react-router-dom"; //Link
import { useState } from "react";

export default function CartSidebar({ cartOpen, setCartOpen }) {

const [counter, setCounter] = useState(1);
  const inc = () => {
    setCounter(counter + 1);
  };

  const dec = () => {
    if (counter > 1) {
      setCounter(counter - 1);
    }
  };

  const [counter2, setCounter2] = useState(1);
  const inc2 = () => {
    setCounter2(counter2 + 1);
  };

  const dec2 = () => {
    if (counter2 > 1) {
      setCounter2(counter2 - 1);
    }
  };


  return (
    <>
      <div className={`base ${cartOpen ? "active" : ""}`}>
        <div className="sidebar_filter_main">
          <div className="sidebar_filter_header">
            <h1>Cart</h1>
            <button className="close_btn" onClick={() => setCartOpen(false)}>
              ✕
            </button>
          </div>
          <div className="filter_cart">
            <div className="cart-item">
              <img src={cartImg} alt="" className="img-fluid" />

              <div className="cart-details">
                <div className="cart-name">
                  Nazakat Hand Woven Beige Cotton Cushion Cover
                </div>
                <div className="cart-meta">SKU: CU03970001_1.04x1.04</div>
                <div className="cart-meta">Size: 46x46 cm</div>
                <div className="cart-meta">Color: Cream</div>
                <div className="cart-price">₹ 3,000</div>

                <div>
                  <div className="qty-box">
                    <button onClick={dec}>-</button>
                    <p className="number">{counter}</p>
                    <button onClick={inc}>+</button>
                  </div>
                  <button className="remove-btn">×</button>
                </div>
              </div>
            </div>
             <div className="cart-item">
              <img src={cartImg} alt="" className="img-fluid" />

              <div className="cart-details">
                <div className="cart-name">
                  Nazakat Hand Woven Beige Cotton Cushion Cover
                </div>
                <div className="cart-meta">SKU: CU03970001_1.04x1.04</div>
                <div className="cart-meta">Size: 46x46 cm</div>
                <div className="cart-meta">Color: Cream</div>
                <div className="cart-price">₹ 3,000</div>

                <div>
                  <div className="qty-box">
                  <button onClick={dec2}>-</button>
                  <p className="number">{counter2}</p>
                  <button onClick={inc2}>+</button>
                  </div>
                  <button className="remove-btn">×</button>
                </div>
              </div>
            </div>

            <div className="cart_total_box">
              <p>Taxes & Shipping calculated at checkout</p>
              <div className="cart_total_price">
                <p>Total</p>
                <p>₹ 9,000.00</p>
              </div>
              <div className="cart_buttons">
                
                <button className="view_Cart">
                  <Link to="/cart"> View Cart</Link>
                  </button>
                <button className="checkout_btnn">
                   <Link to="/checkout"> Checkout</Link>
                  </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
